import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ListServerPaginationStateModel, LIST_SERVER_PAGINATION_INITIAL_STATE } from '../../../../../../common/models';
import { catchError, map } from 'rxjs/operators';
import { FailedMessagesProfileItemModel } from '../../models/profile/failed-messages-profile-item.model';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { Observable, of } from 'rxjs';
import { SimpleSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import {
  FailedMessagesProfileListLoad,
  FailedMessagesProfileListInitialState,
} from './failed-messages-profile-list.actions';
import { FailedMessagesProfileListService } from './failed-messages-profile-list.service';

export type FailedMessagesProfileListStateModel = ListServerPaginationStateModel<FailedMessagesProfileItemModel>;

const initialState: FailedMessagesProfileListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<FailedMessagesProfileListStateModel>({
  name: 'failedMessagesProfileList',
  defaults: initialState,
})
@Injectable()
export class FailedMessagesProfileListState {
  constructor(
    private failedMessagesProfileListService: FailedMessagesProfileListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: FailedMessagesProfileListStateModel): FailedMessagesProfileListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: FailedMessagesProfileListStateModel): FailedMessagesProfileItemModel[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: FailedMessagesProfileListStateModel): boolean {
    return state.loaded;
  }

  @Action(FailedMessagesProfileListLoad)
  getFailedMessagesProfileList(
    ctx: StateContext<FailedMessagesProfileListStateModel>,
    { payload }: FailedMessagesProfileListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.failedMessagesProfileListService.getProfileList(payload).pipe(
      map((profileList: FailedMessagesProfileListStateModel) => {
        ctx.patchState({ ...profileList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(FailedMessagesProfileListInitialState)
  setInitialState(ctx: StateContext<FailedMessagesProfileListStateModel>): void {
    ctx.setState(initialState);
  }
}
